import { AbstractControl, ValidatorFn } from '@angular/forms';
import { parsePhoneNumber, PhoneNumber } from 'libphonenumber-js';

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const error = {
      validatePhoneNumber: true,
    };
    let numberInstance: PhoneNumber;
    if (control.value) {
      try {
        numberInstance = parsePhoneNumber(
          control.value.number,
          control.value.countryCode
        );
      } catch (e) {
        return error;
      }

      if (numberInstance && !numberInstance.isValid()) {
        return error;
      }
    }
    return null;
  };
}
